import React from 'react';
import { ReactComponent as Search } from '../../Assets/search-icon.svg';
import './search.styles.scss';

export const SearchBox = ({handleSearch}) => {
    const handleTrigger = () => {
        const input = document.querySelector('.search-wrapper');
        input.classList.toggle('open');
    }

    return (
        <div className="search-wrapper">
            <button className="trigger-search" onClick={handleTrigger}>
                <span className="btn__content" tabIndex="-1">
                    <Search />
                </span>
            </button>
            <input 
                type="search"
                placeholder="Search..."
                onChange={handleSearch}
            />
        </div>
    )
}